import React from 'react';
import styled from 'styled-components';
import { Column, Text } from '../theme';
import test1 from '../../assets/testimonialport1.jpg';
import test2 from '../../assets/testimonialport2.jpg';
import test3 from '../../assets/testimonialport3.jpg';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3em 0;
  justify-content: center;
`;

const StyledBox = styled(Column)`
  width: 100%;
  height: 100%;
  align-items: center;
  margin: 2em 0;
`;

const Img = styled.img`
  height: 172px;
  margin-bottom: 2em;
`;

const Grid = styled.div`
  width: 85%;
  display: grid;
  grid-gap: 50px;
  height: 100%;
  margin: 3em auto;
  grid-template-columns: repeat(auto-fit, minmax(225px, 1fr));
  grid-auto-rows: auto;
`;

// const StyledColumn = styled(Column)`
//   width: 50%;
//   marginp: 0 auto;
//   text-align: center;
//   @media (max-width: 720px) {
//     width: 95%;
//   }
// `;

const values = [
  {
    name: 'Jason H.',
    text:
      'Interesting topics, concie and organized. Thank you for a great and painless CE experience.',
    img: test1,
  },
  {
    name: 'Jennifer T.',
    text:
      'This was a great package. It was informative, easy to digest and very well organized! Overall, it was convenient and took all the guesswork out. Thanks so much AchieveCE!',
    img: test2,
  },
  {
    name: 'Veronica M.',
    text:
      'Very informative and up to date courses at a great price. Loved it!!!',
    img: test3,
  },
];

function Testimonial({ img, name, text }) {
  return (
    <StyledBox>
      <Img src={img} alt={`${img} Icon AchieveCE`} />
      <Column width="85%">
        <Text>{`"${text}"`}</Text>
        <Text>{`- ${name}`}</Text>
      </Column>
    </StyledBox>
  );
}

function Testimonials() {
  return (
    <Wrapper>
      {/* <Title>Values</Title> */}
      <Grid>
        {values &&
          values.map((key, index) => {
            return (
              <Testimonial
                key={index}
                img={key.img}
                name={key.name}
                text={key.text}
              />
            );
          })}
      </Grid>
      {/* <StyledColumn>
        <Text protitle>Sign up for 10% off</Text>
        <Text>
          Yes, it's that easy! <br /> We're here to make sure you have <br /> a
          seamless and enjoyable CE renewal experience. <br /> Include your
          email for updates and discounts.
        </Text>
      </StyledColumn>
      <Row justifycontent="center" margin="1em 0 2em 0">
        <Input testimonial placeholder="Enter your email" />
        <Button testimonial>Subscribe</Button>
      </Row> */}
    </Wrapper>
  );
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/shared/Testimonials2.jsx